import {
    AppResponse,
    IHomePagePredictionScore,
    IHomePagePredictionScoreDetail,
    IPredictionScoreExamPointDetail,
    IPredictionScoreExamPointChart,
    IPredictionScoreExamPointRecommendResource,
    IPredictScoreFeedbackType,
    IPredictScoreExamPointChartAndScore,
    IPredictScoreCompletedExamPoint,
} from '@/types';
import Http from '@/utils/http';

// 获取学员当前考季下预测分
export const getHomePagePredictionScore = (
    params: {
        examSeasonId: number;
        projectId: number;
        subjectId: number;
    },
    option: { isVisit: boolean }
): Promise<AppResponse<IHomePagePredictionScore>> => Http.post('/minerva/api/v1/front/predict-score', params, option);

// 预测分详情
export const getHomePagePredictScoreDetailInfo = (params: {
    examSeasonId: number;
    examSyllabusId: number;
    projectId: number;
    subjectId: number;
}): Promise<AppResponse<IHomePagePredictionScoreDetail>> => Http.post('/minerva/api/v1/front/predict-score/detail/info', params);

// 保存学员预测分配置
export const saveHomePagePredictScoreDetail = (params: {
    examSeasonId: number;
    examSyllabusId: number;
    projectId: number;
    subjectId: number;
    sectionList: {
        goalScore: number;
        sectionId: number;
    }[];
}): Promise<AppResponse<IHomePagePredictionScoreDetail>> => Http.post('/minerva/api/v1/front/predict-score/detail/save', params);

// 获取当前所选考季考纲的考点详情
export const getPredictScoreExamPointDetail = (params: {
    projectId: number; // 项目id
    subjectId: number; // 科目id
    examSeasonId: number; // 考季id
    knowledgeId: number; // 考点ID
    knowledgeSource: number; // 考点来源 0 预测分 1 解析也考点标签
}): Promise<AppResponse<IPredictionScoreExamPointDetail>> =>
    Http.post('/minerva/api/v1/front/predict-score/knowledge-point/detail', params);

// 考点掌握情况图表
export const getPredictScoreExamPointChart = (params: {
    projectId: number; // 项目id
    subjectId: number; // 科目id
    examSeasonId: number; // 考纲id
    knowledgeId: number; // 考点ID
}): Promise<AppResponse<IPredictionScoreExamPointChart>> => Http.post('/minerva/api/v1/front/predict-score/knowledge-point/chart', params);

// pc端获取当前所选考季考纲的考点推荐资源
export const getPredictScoreExamPointRecommendResource = (params: {
    courseId?: number;
    knowledgeId: number;
    projectId: number;
    subjectId: number;
    queryType: number; // 查询类型 0 首次进入，1 查询指定课程(courseId不能为空) 2 查询考点
    pageNum: number;
    pageSize: number;
    examSeasonId: number; // 考季id
}): Promise<AppResponse<IPredictionScoreExamPointRecommendResource>> =>
    Http.post('/student-learning/api/v1/front/knowledge-point/recommend-resource/page/pc', params);

// 意见反馈接口
export const getPredictScoreFeedbackType = (params: {
    projectId: number;
    subjectId: number;
    examSyllabusId?: number;
    sectionId?: number;
}): Promise<AppResponse<IPredictScoreFeedbackType>> => Http.post('/minerva/api/v1/front/predict-score/feedback/type', params);

// 预测分反馈
export const savePredictScoreFeedback = (params: {
    projectId: number;
    subjectId: number;
    examSeasonId: number;
    examSyllabusId?: number;
    sectionId?: number;
    content: string;
    feedbackType: number;
    imagesList?: string[];
}): Promise<AppResponse<any>> => Http.post('/minerva/api/v1/front/predict-score/feedback', params);

// 预测分考点抽题
export const createPredictScoreExamPointPractice = (params: {
    projectId: number;
    subjectId: number;
    examSeasonId: number;
    sourceFromType: number;
    knowledgeId: number;
    knowledgeTitle: string;
    businessParam?: any;
}): Promise<AppResponse<{ paperDataLogId: number }>> => Http.post('/minerva/api/v1/front/predict-score/knowledge/question/do-item', params);

// 创建考点练习，弹窗展示-预测分上涨分数和图表
export const getPredictScoreExamPointChartAndScore = (params: {
    projectId: number;
    subjectId: number;
    paperDataLogId: number;
}): Promise<AppResponse<IPredictScoreExamPointChartAndScore>> =>
    Http.post('/minerva/api/v1/front/predict-score/knowledge-point/rise', params);

// 获取当前考季学员达标的考点
export const getPredictScoreCompletedExamPoint = (params: {
    projectId: number;
    subjectId: number;
    examSeasonId: number;
    devMode?: number;
}): Promise<AppResponse<IPredictScoreCompletedExamPoint>> => Http.post('/minerva/api/v1/front/predict-score/complete-knowledge', params);

// 保存资源进度
export const asyncStudyProgress = (params: {
    resource_id: number;
    cs_item_id: number;
    course_id: number;
    status: number;
}): Promise<AppResponse<any>> => Http.post('/ep-study/front/progress/sync', params);
// 保存资源进度
export const getDownloadPaperUrl = (params: { paperId: number }): Promise<AppResponse<any>> =>
    Http.get('/minerva/api/v1/front/download/paper', params);
